/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import type { ModelRegistry } from 'ember-data/types/registries/model';
import UiBookingSummaryAcceptV1Component from 'uplisting-frontend/components/ui/booking/summary/accept/v1';

interface IArgs {
  booking: ModelRegistry['booking'];
}

export interface BookingAcceptV2Signature {
  Element: HTMLDivElement;

  Args: IArgs;
}

export default class UiBookingSummaryAcceptV2Component extends UiBookingSummaryAcceptV1Component {
  readonly closeRoute = 'monthly';
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Booking::Summary::Accept::V2': typeof UiBookingSummaryAcceptV2Component;
  }
}
